module.exports = __webpack_public_path__ + "img/zuobiao-green.2b289f52.svg";